"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAnalyticsProvider = void 0;
const TIME_FOR_TRACK_PAGE = 10000;
class BaseAnalyticsProvider {
    constructor() {
        this.isInitialized = false;
    }
    get identityData() {
        return this.identity;
    }
    identify(identity) {
        if (!identity.hasOwnProperty('id')) {
            throw new Error('The input data must have an id property.');
        }
        const { id, email, firstname: firstName, lastname: lastName, fullname: name, phone, plan } = identity;
        this.identity = {
            id: id,
            email: email,
            firstName: firstName,
            lastName: lastName,
            name: name,
            phone: phone,
            plan: plan
        };
        this.identifyUser(this.identity);
    }
    updateIdentity(data) {
        if (!this.isInitialized) {
            return;
        }
        const { id, userProps } = data;
        this.updateUserIdentity(id, userProps);
        this.trackPage();
        setTimeout(() => {
            this.trackPage();
        }, TIME_FOR_TRACK_PAGE);
    }
    trackEvent(eventName, category, eventProperties) {
        var _a;
        if (!this.isInitialized) {
            return;
        }
        if (!((_a = this.identity) === null || _a === void 0 ? void 0 : _a.id)) {
            return;
        }
        const properties = {};
        properties.metadata = {
            urlHash: window.location.hash
        };
        if (category && category.length > 0) {
            properties.category = category;
        }
        if (this.identity.email) {
            properties.email = this.identity.email;
        }
        if (this.identity.id) {
            properties.id = this.identity.id;
        }
        if (eventProperties) {
            Object.getOwnPropertyNames(eventProperties).forEach((prop) => {
                properties[prop] = eventProperties[prop];
            });
        }
        this.track(eventName, properties);
    }
    logout() {
        if (!this.isInitialized) {
            return;
        }
        this.performLogout();
        this.isInitialized = false;
    }
}
exports.BaseAnalyticsProvider = BaseAnalyticsProvider;
